<template>
    <router-link 
        v-tooltip.right="!isExpanded && title" 
        :to="to" 
        class="button"
        :disabled="disabled"
        :class="{ 'menu-item-disabled': disabled }"
        @click="handleClick"
    >
        <span  :class="`pi icon ${icon}`" />
        <span v-if="isExpanded" class="menu-text">{{ title }}</span>
    </router-link>
</template>

<script setup>
const emit = defineEmits(['menuClick']);

const props = defineProps({
    title: {
        type: String,
        required: true
    },
    icon: {
        type: String,
        required: true
    },
    to: {
        type: [String, Object],
        required: true
    },
    isExpanded: {
        type: Boolean,
        required: true
    },
    isMobile: {
        type: Boolean,
        required: true
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const handleClick = () => {
    if (props.isMobile) {
        emit('menuClick');
    }
};
</script>

<style scoped>
.button {
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0.5rem 1rem;
    transition: 0.2s ease-out;
    margin-top: 0.2rem;
}

.menu-item-disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
    color: var(--gray-600);
}

.menu-item-disabled.router-link-exact-active {
    background-color: transparent !important;
    border-right: none !important;
}

.menu-item-disabled .pi,
.menu-item-disabled .menu-text {
    color: var(--gray-600) !important;
}

.button:not(.menu-item-disabled):hover {
    transform: translateX(0.6rem);
    background-color: var(--dark-alt);
    color: hsl(222, 57%, 43%);
}

.router-link-exact-active:not(.menu-item-disabled) {
    background-color: var(--dark-alt);
    border-right: 5px solid var(--primary);
}

.router-link-exact-active:not(.menu-item-disabled) .pi,
.router-link-exact-active:not(.menu-item-disabled) .menu-text {
    color: var(--primary)
}

.button .pi {
    font-size: 1.5rem;
    transition: 0.2s ease-out;
}

.menu-text {
    transition: 0.3s ease-out;
    margin-left: 0.5rem;
}

:deep(.button .pi) {
    margin-right: v-bind('isExpanded ? "1rem" : "0"');
}
</style> 